import React, { MouseEvent, ReactNode } from "react";

interface ButtonProps {
  isLoading?: boolean;
  disabled?: boolean;
  submit?: boolean;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  children?: ReactNode;
  [key: string]: any; // Allow any other props
}

export function Button({
  isLoading,
  disabled,
  submit,
  children,
  onClick,
  className = "",
  ...props
}: ButtonProps) {
  return (
    <button
      type={submit ? "submit" : "button"}
      disabled={disabled || isLoading}
      onClick={onClick}
      {...props}
      className={`p-2 rounded-full text-center bg-brand-color h-12 w-full text-black hover:bg-brand-hover flex disabled:bg-opacity-50 disabled:!text-opacity-50 disabled:cursor-not-allowed justify-center items-center gap-2 font-semibold px-3 py-4 ${className} ${
        isLoading ? "disabled:cursor-progress pointer-events-none " : ""
      }`}
    >
      {isLoading && (
        <span className="rounded-full border-white block size-4 border-2 border-t-black animate-spin" />
      )}
      {children}
    </button>
  );
}

export function SecondaryButton({
  isLoading,
  disabled,
  submit,
  children,
  onClick,
  className = "",
  ...props
}: ButtonProps) {
  return (
    <button
      type={submit ? "submit" : "button"}
      onClick={onClick}
      {...props}
      disabled={disabled || isLoading}
      className={`disabled:bg-[#D9DFE6] border border-[#D9DFE6] disabled:bg-opacity-50 flex disabled:cursor-not-allowed flex-row justify-center items-center gap-2 text-[#333333] hover:bg-[#D9DFE6] h-12 font-medium rounded-xl w-full px-3 py-4 ${className}`}
    >
      {isLoading && (
        <span className="rounded-full border-white block size-4 border border-t-brand-color animate-spin" />
      )}
      {children}
    </button>
  );
}
